<h2 mat-dialog-title>

  <span *ngIf="selectedReference.title">{{'COMMON.EDIT' | translate}} - {{selectedReference.title}}</span>
  <span *ngIf="!selectedReference.title">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">


  <mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab class="modal-tab" label="{{'REFERENCE.TAB.0' | translate}}*"></mat-tab>
    <mat-tab class="modal-tab" label="{{'REFERENCE.TAB.1' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'REFERENCE.TAB.2' | translate}}*"></mat-tab>
    <mat-tab class="modal-tab" label="{{'REFERENCE.TAB.3' | translate}}"></mat-tab>
  </mat-tab-group>

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div [hidden]="activeTabIndex !== 3" class="gallery-uploader-container row">

        <app-custom-drop-zone
          [class.col-12]="!selectedReference.galleryImages || !selectedReference.galleryImages.length"
          [class.col-4]="selectedReference.galleryImages && selectedReference.galleryImages.length"
          (uploadFinished)="galleryImageUploadFinished($event)"
          [uploadPath]="'referenceGallery'"
          [height]="'250px'">
        </app-custom-drop-zone>

        <div class="image-list col-8" *ngIf="selectedReference.galleryImages && selectedReference.galleryImages.length">

          <div class="row">
            <div class="image-item col-4" *ngFor="let galleryItem of selectedReference.galleryImages">

              <img [src]="galleryItem.imageUrl">

              <mat-icon class="dark" (click)="deleteGalleryItem(galleryItem)">
                delete
              </mat-icon>
            </div>
          </div>

        </div>

      </div>

      <div [hidden]="activeTabIndex !== 2" class="uploader-container">
        <img *ngIf="selectedReference && selectedReference.imageUrl" [src]="selectedReference.imageUrl">
        <mat-icon class="dark" *ngIf="selectedReference && selectedReference.imageUrl" (click)="deleteCoverImage()">
          delete
        </mat-icon>

        <app-custom-drop-zone
          *ngIf="!selectedReference || !selectedReference.imageUrl"
          (uploadFinished)="onUploadFinished($event)"
          [uploadPath]="'reference'"
          [height]="'250px'">
        </app-custom-drop-zone>

      </div>

      <div [hidden]="activeTabIndex !== 1">

        <app-html-editor-wrapper
          [value]="form.controls['body'].value"
          [editMode]="true" [showButtons]="false"
          (contentChanged)="onReferenceContentChanged($event)"></app-html-editor-wrapper>

      </div>

      <div [hidden]="activeTabIndex !== 0">
        <div class="row">
          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'REFERENCE.TITLE' | translate}}"
                     formControlName="title">

            </mat-form-field>

          </div>

          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'REFERENCE.TYPE' | translate}}"
                     formControlName="type">

            </mat-form-field>

          </div>

          <div class="col-12">
            <mat-form-field>
              <input
                (click)="openCalendar()"
                readonly
                formControlName="createdAt" autocomplete="false" matInput [matDatepicker]="picker"
                placeholder="{{'REFERENCE.CREATED_AT' | translate}}">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView="year" [startAt]="startDate"></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field>
              <mat-label>{{'REFERENCE.SUMMARY' | translate}}</mat-label>
              <textarea matInput formControlName="summary" matTextareaAutosize matAutosizeMinRows=2
                        matAutosizeMaxRows=5></textarea>
            </mat-form-field>
          </div>

        </div>
      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
